var path = '/public-client/templates/widget-body.html';
var html = "<div id=\"{{widget._id}}\" page=\"{{page._id}}\" class=\"widget\">\n\t<div class=\"loading-indicator loading\" translate>\n\t\t<div class=\"signal\"></div>\n\t\tVIEWRESULTS.WIDGET_LOADING\n\t</div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;